import React from "react";
import { useDrag } from "react-dnd";

// Components
import LeadCard from "./LeadCard";

const DraggableLead = (props) => {
    const [{ opacity }, dragRef] = useDrag({
        type: 'lead',
        item: { ...props },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            opacity: monitor.isDragging() ? 0.4 : 1,
        }),
    });

    const handleSelectedLead = (e) => {
        e.preventDefault();
        props.onSelectLead(props.item);
    }

    const style = { cursor: 'grab' };

    return (
        <div ref={ dragRef } style={{ ...style, opacity }} onClick={ handleSelectedLead }>
            <LeadCard className={ props.className } item={ props.item } />
        </div>
    );
};

export default DraggableLead;
